import script from "./paidSupplier.vue?vue&type=script&setup=true&lang=js"
export * from "./paidSupplier.vue?vue&type=script&setup=true&lang=js"

import "./paidSupplier.vue?vue&type=style&index=0&id=5c7b5f70&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c7b5f70"]])

export default __exports__